<template>
    <div class="photo-wrapper rounded text-center">
        <div v-if="image" class="position-relative d-inline-block">
            <img :src="getThumb()" class="doc_image">
            <button type="button" class="btn-remove" @click="removeImage()">x</button>
        </div>
        <div v-else-if="type == 'browse'">
            <div class="btn-choose-photo border-0 m-0 p-0 w-100">
                <button type="button"
                    class="btn btn-outline-grey fz-16 fw-300 m-0 d-flex align-items-center justify-content-center w-100">
                    <img :src="`${publicPath}/img/rcp/icon/solar_gallery-add-bold.png`" class="mr-1">
                    <span>{{ $t('Browse') }}</span>
                </button>
                <FileComponent @file-updated="captureFile($event)" @on-error="onError" :allowedTypes="allowed_types"
                    :size="size"></FileComponent>
            </div>
        </div>
        <div v-else>
            <button type="button"
                class="btn btn-outline-grey fz-16 fw-300 d-flex align-items-center justify-content-center w-100"
                @click="toggleCamera()">
                <img :src="`${publicPath}/img/rcp/icon/take-photo.png`" class="mr-1" width="24">
                <span>{{ $t('Take Photo') }}</span>
            </button>
        </div>
        <div v-if="error_msg" class="invalid-feedback d-block mb-3">
            {{ $t(error_msg) }}
        </div>
    </div>
</template>
<script>

import FileComponent from "@/components/FileComponent";

export default {
    name: 'file-uploader',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            image: '',
            extension: '',
            error_msg: ''
        }
    },
    props: ['type', 'default_image', 'allowed_types', 'size'],
    components: {
        FileComponent
    },
    methods: {
        onError(message) {
            this.error_msg = message;
        },
        getThumb() {
            let tmp = this.image;
            let check_ext = '';

            if (tmp.indexOf("http://") != -1 || tmp.indexOf("https://") != -1) {
                let arr_check = tmp.split(".");
                check_ext = arr_check[arr_check.length - 1];
            }
            else {
                check_ext = this.getFileExtension(tmp);
            }

            if (check_ext == "pdf") {
                this.extension = "pdf";
                return this.publicPath + "/img/gep/pdf.png";
            }
            else if (check_ext.indexOf("zip") != -1) {
                this.extension = "zip";
                return this.publicPath + "/img/gep/zip.png";
            }
            else if(check_ext.indexOf("x-rar")!=-1 || check_ext.indexOf("rar")!=-1 || check_ext.indexOf("x-compressed")!=-1 || check_ext.indexOf("octet-stream")!=-1){
                this.extension = "rar";
                return this.publicPath + "/img/gep/rar.png";
            }
            else if (check_ext.indexOf("doc") != -1) {
                console.log('Icon DOC dijalankan');
                this.extension = "doc";
                return this.publicPath + "/img/gep/doc.png";
            }
            else if (check_ext == "xlx" || check_ext == "xlsx" || check_ext == "csv") {
                this.extension = check_ext;
                return this.publicPath + "/img/gep/excel.png";
            }
            else {
                this.extension = check_ext;
                return this.image;
            }
        },
        getFileExtension2() {
            let tmp = this.image;
            let check_ext = this.getFileExtension(tmp);

            if (check_ext.indexOf("zip") != -1) {
                return "zip";
            }
            else if (check_ext.indexOf("x-compressed") != -1) {
                return "rar";
            }
            else if (check_ext.indexOf("doc") != -1) {
                return "doc";
            }
            else {
                return check_ext;
            }
        },
        getFileExtension(base64String) {
            // Ambil bagian sebelum ";base64" dan hapus "data:" di depannya
            const mimeType = base64String.replace('data:', '').split(';')[0];

            // Ambil bagian setelah "application/"
            const extension = mimeType.split('/')[1];

            return extension;
        },
        captureFile($event) {
            this.error_msg = '';
            this.image = $event.previewBase64;
            this.extension = this.getFileExtension2();
            this.$emit('capture-file', $event.previewBase64);
        },
        removeImage() {
            this.error_msg = '';
            this.image = '';
            this.$emit('remove-image');
        },
        toggleCamera() {
            this.$emit('toggle-camera');
        }
    },
    mounted() {

    }
};
</script>
